import { useState } from 'react';

// Dialog children stay mounted through the close transition; the gating value is
// cleared on close, so keep the last non-nullish one to render through the exit.
export const useRetainedValue = <T>(value: T): T => {
  const [retained, setRetained] = useState(value);

  if (value != null && value !== retained) {
    setRetained(value);
  }

  return value ?? retained;
};
